import React from "react";
import { useNavigate } from "react-router";

const BackButton = ({ goPreviousStep }) => {
  let navigate = useNavigate();

  return (
    <div className="mt-5 align-middle tablet:mb-3">
      <button
        onClick={() => {
          goPreviousStep(navigate);
        }}
      >
        <svg
          width="12"
          height="13"
          viewBox="0 0 12 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.25 6.5H1.5M6 1.25L0.75 6.5L6 11.75"
            stroke="#050033"
            stroke-width="1.125"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span className="mx-2 underline text-[#050033] text-xs font-semibold font-inter">
          Back
        </span>
      </button>
    </div>
  );
};

export default BackButton;
